import React from 'react';
import logo from '../../Assets/logolight.png';
import ig from '../../Assets/ig.png';
import x from '../../Assets/x2.png';
import twitter from '../../Assets/twitter.png';
import linkedin from '../../Assets/linkedin2.png';
import classes from './Footer.module.css';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <div>
            <div className={classes.footer}>
                <div className={classes.dkks}>
                    <div className={classes.dkkss}>
                        <div className={classes.footerlogo}>
                            <div>
                                <Link to={'/'} ><img src={logo} className={classes.footerlogoimg} alt="Logo" /></Link>
                                <p className={classes.footerlogotxt}>Your Partner in Digital Excellence – From Development to Growth.</p>
                            </div>
                            {/* <div>
                        <p className={classes.footerlogotxt1}>Follow Our Socials</p>
                        <div className={classes.footericons}>
                            <img src={ig} className={classes.footerimg} alt="ig icon" />
                            <img src={x} className={classes.footerimg} alt="x icon" />
                            <img src={twitter} className={classes.footerimg} alt="twitter icon" />
                            <img src={linkedin} className={classes.footerimg} alt="linkedin icon" />
                        </div>
                    </div> */}
                        </div>
                        <div className={classes.footerlinks}>
                            <div className={classes.footerlink1}>
                                <p className={classes.company}>Company</p>
                                <div className={classes.footerlink}>
                                    <Link to="/" ><p className={classes.footerlinktxt}>Home</p></Link>
                                    <Link to="/about_us" ><p className={classes.footerlinktxt}>About</p></Link>
                                    <Link to="#"><p className={classes.footerlinktxt}>Portfolio</p></Link>
                                </div>
                            </div>
                            <div className={classes.footerlink1}>
                                <p className={classes.company}>Resources</p>
                                <div className={classes.footerlink}>
                                    <Link to="/faq" ><p className={classes.footerlinktxt}>FAQ</p></Link>
                                    <Link to="/blog" ><p className={classes.footerlinktxt}>Blogs</p></Link>
                                    {/* <Link to="/portfolio"><p className={classes.footerlinktxt}>Portfolio</p></Link> */}
                                </div>
                            </div>
                            <div className={classes.footerlink1}>
                                <p className={classes.company}>Resources</p>
                                <div className={classes.footerlink}>
                                    <Link to="#" ><p className={classes.footerlinktxt}>Privacy Policy</p></Link>
                                    <Link to="/terms_of_service"><p className={classes.footerlinktxt}>Terms of Service</p></Link>
                                    <Link to="/cookie"><p className={classes.footerlinktxt}>Cookie Policy</p></Link>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div>
                        <p className={classes.footerlogotxt1}>Follow Our Socials</p>
                        <div className={classes.footericons}>
                            <img src={ig} className={classes.footerimg} alt="ig icon" />
                            <img src={x} className={classes.footerimg} alt="x icon" />
                            <img src={twitter} className={classes.footerimg} alt="twitter icon" />
                            <Link to="https://www.linkedin.com/company/scaleworkfllow/"><img src={linkedin} className={classes.footerimg} alt="linkedin icon" /></Link>
                        </div>
                    </div>
                </div>
                <div className={classes.footercontact}>
                    <p className={classes.swfc}>©Scaleworkflow. Building effective solutions for businesses</p>
                </div>

            </div>
        </div>
    );
}

